const iconFormats = {
  PNG: 'png',
  GIF: 'gif',
  SVG: 'svg',
};

export default iconFormats;
